import RootEpic from '../epics'
import { createApi, rawEndpoints, type ApiEndpoints } from '../services/api'
import { createNextApi, rawNextEndpoints, type NextApiEndpoints } from '../services/nextApi'

export type ApisType = {
  api: ApiEndpoints
  next: NextApiEndpoints
  setToken: (name: string, token: string) => void
  connect: (getState: () => void, dispatch: (...args: any[]) => void) => void
}

export const createApis = () => {
  const api = rawEndpoints(createApi())
  const next = rawNextEndpoints(createNextApi())
  const apis = {
    api,
    next,
    connect: (getState: () => {}, dispatch: () => {}) => {
      apis.api.connect(getState, dispatch)
    },
  } as ApisType

  const rootEpic = RootEpic(apis)
  return {
    apis,
    rootEpic,
  }
}

export type CreateApis = typeof createApis
